module.exports = __webpack_public_path__ + "img/1629194476212.12b5b0e9.jpeg";